import { DeviceModelWithoutStatusOutput } from './device-model-without-status-output.model';


export class DeviceModelSelectActiveOutput implements IDeviceModelSelectActiveOutput {
    status!: number;
    message!: string;
    data!: DeviceModelWithoutStatusOutput[];

    constructor(data?: IDeviceModelSelectActiveOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DeviceModelWithoutStatusOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceModelSelectActiveOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModelSelectActiveOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDeviceModelSelectActiveOutput {
    status: number;
    message: string;
    data: DeviceModelWithoutStatusOutput[];
}

